<div #wrapperElement class="feature-wrapper h-100">
    <div #headerElement class="feature-wrapper__topper" [ngStyle]="{'background-color': mediaData?.color.bar.bottom}">
      <span class="mr-4">
        <img *ngIf="defineBgColorBarTop === 'dark'" (click)="goBackToMain()" [src]="weblinkIcons.back" width="20" height="20" alt="back-button" class="feature-wrapper__clickable">
        <img *ngIf="defineBgColorBarTop === 'light'" (click)="goBackToMain()" [src]="weblinkIcons.back_dark" width="20" height="20" alt="back-button" class="feature-wrapper__clickable">
      </span>
      <span *ngIf="mediaData.type !== 'WC'">
        <img class="feature-wrapper__img mr-2" width="20" height="20" alt="icon"
          [src]="mediaData?.co_icon"
          [ngClass]="(defineBgColorBarTop === 'dark') ? 'feature-wrapper__border-white' : 'feature-wrapper__border-black'">
        <img class="feature-wrapper__img mr-2" width="20" height="20" alt="icon"
          [src]="mediaData?.co_logo"
          [ngClass]="(defineBgColorBarTop === 'dark') ? 'feature-wrapper__border-white' : 'feature-wrapper__border-black'">
      </span>
      <div class="feature-wrapper__topper-text">
        <div class="feature-wrapper__topper-name feature-wrapper__text-bold"
          [ngClass]="(defineBgColorBarTop === 'dark') ? 'feature-wrapper__text-white' : 'feature-wrapper__text-black'"> {{mediaData?.name}} </div>
        <div class="feature-wrapper__topper-title feature-wrapper__text-light feature-wrapper__topper-description" *ngIf="mediaData?.type !== 'WC'"
          [ngClass]="(defineBgColorBarTop === 'dark') ? 'feature-wrapper__text-white' : 'feature-wrapper__text-black'"> {{mediaData?.co_name}} </div>
        <div class="feature-wrapper__topper-title feature-wrapper__text-light feature-wrapper__topper-description" *ngIf="mediaData?.type === 'WC'"
          [ngClass]="(defineBgColorBarTop === 'dark') ? 'feature-wrapper__text-white' : 'feature-wrapper__text-black'"> {{mediaData?.description}} </div>
      </div>
    </div>
    <div class="feature-wrapper__video" [ngClass]="{'feature-wrapper__overflow-behaviour': isDeviceIOS}" [style.height.px]="450"> <!--wrapperHeight-->
      <div class="feature-wrapper__video-none text-left pl-3" *ngIf="!!mediaData?.featured_contents?.length || !mediaData?.featured_contents">
        <span>No media to display.</span>
      </div>
        <div class="feature-wrapper__video-wrap" *ngFor="let content of mediaData?.featured_contents; let i=index">
          <!-- normal video -->
          <video #videoPlayer controls
            *ngIf="content.isMedia === 'video'"
            class="feature-wrapper__iframe"
            width="100%" height="100%"
            [src]="content.uri">
          </video>
          <!-- youtube -->
          <iframe
            *ngIf="content.isMedia === 'youtube'"
            class="feature-wrapper__iframe"
            width="100%" height="100%"
            [src]="content.uri | safe">
          </iframe>
    
          <!-- photo -->
          <img *ngIf="content.isMedia === 'photo'" class="feature-wrapper__iframe" width="100%" [src]="content.uri" />
    
          <!-- pdf -->
          <div *ngIf="content.isMedia === 'pdf'">
            <iframe [src]="modifyPdfUrl(content) | safe" class="feature-wrapper__iframe-pdf" height="{{pdfHeight}}" width="100%" frameborder="0"></iframe>
          </div>
    
          <!-- description -->
          <div class="feature-wrapper__video-title">
            <!-- title -->
            <div class="feature-wrapper__text-bold head mt-1 mb-0"> {{content.title}} </div>
            <div *ngIf="content.subtitle && content.subtitle !== ''">
              <!-- subtitle ellipsis -->
              <div *ngIf="content.longText; else noEllipsis" class="feature-wrapper__subtitle">
                <div 
                  ellipsis=" ... See more"
                  [ellipsis-content]='content.subtitle'
                  (ellipsis-click-more)="showText(content)"
                  style="white-space: pre-wrap;"
                  class="feature-wrapper__text-light feature-wrapper__ellipsis">
                </div>
              </div>
              <!-- longtext nonellipsis -->
              <ng-template #noEllipsis>
                <div class="feature-wrapper__text-light" style="white-space: pre-line;">
                  <span> {{ content.subtitle }} </span>
                  <span
                    (click)="showText(content)"
                    class="feature-wrapper__text-light feature-wrapper__text-seemore feature-wrapper__clickable">
                    See less
                  </span>
                </div>
              </ng-template>
            </div>
    
          </div>
        </div>

    </div>
  </div>